/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface XMPPAuthentication
 */
export interface XMPPAuthentication {
    /**
     * 
     * @type {string}
     * @memberof XMPPAuthentication
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof XMPPAuthentication
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof XMPPAuthentication
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof XMPPAuthentication
     */
    conference_domain?: string;
}

/**
 * Check if a given object implements the XMPPAuthentication interface.
 */
export function instanceOfXMPPAuthentication(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function XMPPAuthenticationFromJSON(json: any): XMPPAuthentication {
    return XMPPAuthenticationFromJSONTyped(json, false);
}

export function XMPPAuthenticationFromJSONTyped(json: any, ignoreDiscriminator: boolean): XMPPAuthentication {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': json['username'],
        'password': json['password'],
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
        'conference_domain': !exists(json, 'conference_domain') ? undefined : json['conference_domain'],
    };
}

export function XMPPAuthenticationToJSON(value?: XMPPAuthentication | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'password': value.password,
        'domain': value.domain,
        'conference_domain': value.conference_domain,
    };
}

